module.exports = __webpack_public_path__ + "img/WinFieldLogo.a6a96f78.jpg";